import React from 'react';
import './CartPickerTriggerText.less';

export const CartPickerTriggerText = ({text}) => {
	return <span className="cart-picker-trigger-text">{text}</span>;
};
